import { shiftServiceApi } from "../../app/shiftServiceApi";
import { API_URL } from "../../constants/apiUrl";
import {
  GetBusinessShiftDetailsResponseType,
  GetBusinessShiftParams,
  GetBusinessShiftResponseType,
  GetQueryArgsType,
  PatchQueryArgsType,
} from "../../types";

export const shiftManagementApi = shiftServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getBusinessShifts: builder.query<
      GetBusinessShiftResponseType,
      GetQueryArgsType<GetBusinessShiftParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getBusinessShifts,
        ...queryArgs,
      }),
      providesTags: ["GetBusinessShifts"],
    }),
    getBusinessShiftDetails: builder.query<
      GetBusinessShiftDetailsResponseType,
      string
    >({
      query: (id) => ({
        url: `${API_URL.getBusinessShiftDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetBusinessShiftDetails", id }],
    }),
    addBusinessShift: builder.mutation({
      query: (data) => ({
        url: API_URL.addBusinessShift,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetBusinessShifts"];
        return [];
      },
    }),
    updateBusinessShift: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateBusinessShift}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetBusinessShifts",
            {
              type: "GetBusinessShiftDetails",
              id,
            },
          ];

        return [];
      },
    }),
    updateBusinessShiftStatus: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateBusinessShiftStatus}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetBusinessShifts",
            {
              type: "GetBusinessShiftDetails",
              id,
            },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useGetBusinessShiftsQuery,
  useGetBusinessShiftDetailsQuery,
  useAddBusinessShiftMutation,
  useUpdateBusinessShiftMutation,
  useUpdateBusinessShiftStatusMutation,
} = shiftManagementApi;
